export enum UsageTab {
  TimeSaved = "Time saved",
  TimeSpent = "Time experimenting",
  SavedVsSpent = "Saved vs experimenting",
}

export const usageTabs = [UsageTab.TimeSaved, UsageTab.TimeSpent] as const;

export type UsageTabType = (typeof usageTabs)[number];
